import { compact, isArray, isString } from 'lodash'

// NOTE: APIのエラーメッセージは文字列(422の `{ status: 'error', message: '...' }`)と
// 配列の両方の形で返る。表示できるメッセージが無ければnullを返し、呼び出し側の固定文言に任せる
export const pickApiErrorMessage = error => {
  const message = error?.response?.data?.message

  if (isArray(message)) {
    const joined = compact(message).join('\n')

    return joined || null
  }

  return isString(message) && message ? message : null
}
